export function getUniqueId(prefix: string = "uid"): string {
  const random =
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);

  return `${prefix}-${random}`;
}
